export default {
  statistics: {
    total_campaigns: 'Totaal campagnes',
    todays_sent_messages: 'Vandaag verzonden berichten',
    total_subscribers: 'Abonnees',
    average_click_rate: 'Gemiddeld klikpercentage',
  },
};
